export const VIEW_DATE_WITH_TIME_FORMAT = 'dd.MM.yyyy HH:mm';
export const VIEW_DATE_FORMAT = 'dd.MM.yyyy';
export const DATE_FORMAT_DD_MM_YY = 'dd.MM.yy';
export const DATE_FORMAT_DD_MM = 'dd.MM';
export const FILE_DATE_WITH_TIME_FORMAT = 'dd_MM_yyyy_HH_mm';
export const VIEW_DATE_WITH_MONTH_FORMAT = 'dd MMM yyyy';
export const VIEW_DATE_WITHOUT_DAY_FORMAT = 'LLLL yyyy';
export const VIEW_DATE_WITHOUT_DAY_YEAR_FIRST_FORMAT = 'yyyy-MM';
export const FILE_DATE_FORMAT = 'dd-MM-yyyy';
export const VIEW_DATE_WITH_FULL_MONTH_FORMAT = 'dd MMMM yyyy';
